
import { useContext, createContext } from 'react';
import axios, {AxiosResponse} from 'axios';

import { ConfigInfoService } from './ConfigInfo';
import { getApiErrorMessage } from './apiErrorMessage';

import { 
  User_WithoutId, 
  UserCreationAsPropertyProfessionalAttributes,
  OfferWithScope_UserWithoutId,
  UserCreationAsBusinessOwnerAttributes,
    } 
  from './DataStructures';

export enum CacheKeys {  
  OFFERS_BY_PROFESSION,
}


export class APIUnauthenticatedService {
  private static instance: APIUnauthenticatedService;
  private API_PATH; 

  private constructor(configInfo: ConfigInfoService) { 
    
    this.API_PATH = configInfo.apiServer;
  }

  public static getInstance = (configInfo: ConfigInfoService) => {

    if (!APIUnauthenticatedService.instance) {
      APIUnauthenticatedService.instance = new APIUnauthenticatedService(configInfo);
    }
    return APIUnauthenticatedService.instance;

  }

  public sendMail = async (text: string, email: string, name: string) : Promise<{message:string}> => {
    try {
      const response = await axios.post<{ message: string }>(
        `${this.API_PATH}/sendmail`,
        { name, email, text },
        { timeout: 2000 }
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(getApiErrorMessage(error));
    }
  }
  

  public getApiInfo= async (): Promise<{message:string}> => {
    const response = await axios.get<{message:string}>(`${this.API_PATH}/info`);
    return response.data;
  };

  public getOffersByProfession = async (profession: string): Promise<OfferWithScope_UserWithoutId[]> => {
    const response = await axios.get<OfferWithScope_UserWithoutId[]>(`${this.API_PATH}/offers/profession/${profession}`);
    return response.data;
  };  
  
  public createUser = async (userToCreate: UserCreationAsPropertyProfessionalAttributes): Promise<User_WithoutId> => {

    try {  
  
      const response = await axios.post<User_WithoutId, AxiosResponse<User_WithoutId>, UserCreationAsPropertyProfessionalAttributes>(`${this.API_PATH}/users/createAsPropertyProfessional`, userToCreate);
      return response.data;

    } 
    catch (error: any) {
      
      throw new Error(getApiErrorMessage(error));
    }
  };

  public createUserAsBusinessOwner = async (userToCreate: UserCreationAsBusinessOwnerAttributes): Promise<User_WithoutId> => {

    try {  
  
      const response = await axios.post<User_WithoutId, AxiosResponse<User_WithoutId>, UserCreationAsBusinessOwnerAttributes>(`${this.API_PATH}/users/createAsBusinessOwner`, userToCreate);
      return response.data;

    } 
    catch (error: any) {
      
      throw new Error(getApiErrorMessage(error));
    }
  };
}


export const APIUnauthenticatedServiceContext = createContext<APIUnauthenticatedService| null>(null);

export function useAPIUnauthenticatedService() {      

    const context = useContext(APIUnauthenticatedServiceContext);

    if (context === null) {
      throw new Error('useAPIUnauthenticatedService must be used within a APIUnauthenticatedServiceContext.Provider');
    }
    return context;

}
